export default __webpack_public_path__ + "static/media/signup_line.87150aed.svg";